import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Slider1 from "@assets/images/logo-sipiat.jpg";
import { Select } from "antd";
import { Mading } from "@services/dtos/home.dto";
import { useQuery } from "@tanstack/react-query";
import { HomeService } from "@services/home.service";
import { FcFinePrint } from "react-icons/fc";
import { Spiner } from "@components/loaders/spiner";
import moment from "moment";

export const MadingListPage = () => {
  const navigate = useNavigate();
  const { setHeader, setAppBar } = useThemeStore((state) => state);
  const [limit, setLimit] = useState<string>("10");

  const kategori = "*";
  const { data: dataMading, isPending: isPendingMading } = useQuery({
    queryKey: [HomeService.queries.GET_MADING, kategori, limit],
    queryFn: () => HomeService.mading(kategori, limit),
  });

  useEffect(() => {
    setHeader({
      buttonBack: true,
      filter: false,
      title: "Informasi SIPiat",
    });
    setAppBar({
      title: "Informasi SIPiat",
      show: true,
      leading: "back",
    });
  }, [setHeader, setAppBar]);

  const openDetailMading = (detailMading: Mading) => {
    navigate(linkPage.MADING_DETAIL, { state: detailMading });
  };

  return (
    <>
      <div className="tw-px-4">
        <div className="tw-bg-other-100 tw-rounded-lg card-body">
          <div className="tw-text-xs tw-mb-1">Filter Data</div>
          <Select
            className="tw-border-other-0 tw-text-base"
            placeholder="Pilih Jumlah Ditampilkan"
            defaultValue={limit}
            style={{ width: "100%" }}
            allowClear
            onChange={(e) => setLimit(e)}
            options={[
              { value: "10", label: "10" },
              { value: "25", label: "25" },
              { value: "50", label: "50" },
              { value: "100", label: "100" },
            ]}
          ></Select>
          <p className="tw-mt-3 tw-text-sm">
            Data yang ditampilkan {limit} data terakhir
          </p>
        </div>
      </div>
      {/* List */}
      <div className="tw-px-4 tw-pb-10">
        {isPendingMading ? (
          <div className="tw-mt-4 tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-text-center">
              <Spiner />
            </div>
          </div>
        ) : dataMading?.data != null && dataMading.data.length > 0 ? (
          <>
            {dataMading.data.map((item, idx) => (
              <div key={idx} onClick={() => openDetailMading(item)}>
                <div className="tw-px-4 tw-py-2 tw-my-4 tw-rounded-md tw-border-none card">
                  <div className="tw-text-base tw-font-bold tw-mb-2 tw-text-other-700">
                    <div className="tw-block tw-text-xs tw-font-light tw-text-other-600">
                      {moment(item.tanggal ?? Date.now()).format(
                        "dddd, DD MMMM YYYY"
                      )}
                    </div>
                  </div>
                  <img
                    className="tw-w-full tw-h-40 tw-rounded-md tw-object-cover"
                    src={item.gambar}
                    alt="gambar mading"
                  />
                  <div className="tw-text-sm tw-text-other-700 tw-mt-3">
                    {item.judul}
                  </div>
                </div>
              </div>
            ))}
          </>
        ) : (
          <div className="tw-mt-4 tw-bg-other-100 tw-rounded-lg card-body">
            <div className="tw-p-8 tw-text-center">
              <FcFinePrint size={50} />
              <div>Data tidak ditemukan</div>
            </div>
          </div>
        )}
      </div>
      {/* end of List */}
    </>
  );
};
